import {
  call, put, takeEvery, select,
} from 'redux-saga/effects';
import { authRequest } from '../../helpers/request.helper';
import { gridFailureAction, gridSuccessAction } from '../actions/creators/grideable.actioncreator';
import { toastDanger } from '../actions/creators/mensajesSistema.actioncreator';

const getItems = state => state.grideable;

function* gridRequest({
  payload: {
    url, endpoint, limite, autoPage = false, appendData = false,
  },
}) {
  const state = yield select(getItems);
  const formData = new FormData();
  const consulta = {};
  const orden = {};
  const grideable = state[endpoint];

  const {
    filters, sorter, datos, tiendaId
  } = grideable;
  const { pagination: { current, pageSize } } = (grideable && grideable.pagination) ? grideable : { pagination: { current: 1, pageSize: limite || 10 } };

  formData.append('limite', pageSize);
  formData.append('comienzo', (current - 1) * pageSize);
  formData.append('modo', 'simple');

  if (tiendaId) {
    formData.append('tienda_id', tiendaId);
  }

  if (sorter) {
    Object.keys(sorter).forEach((item, key) => {
      const { operador } = sorter[item];
      orden[item] = operador;
    });
    formData.append('orden', JSON.stringify(orden));
  }

  if (filters) {
    Object.keys(filters).forEach((item, key) => {
      const { valor, operador } = filters[item];
      consulta[item] = {
        valor,
        operador,
      };
    });
  }
  if (consulta.length !== 0) formData.append('consulta', JSON.stringify(consulta));
  const params = {
    url,
    method: 'POST',
    body: formData,
  };
  try {
    const { datos: responseData, total } = yield call(authRequest, params);
    let nextPage = current;
    if (autoPage) nextPage += 1;

    const outputData = (datos && appendData) ? datos.concat(responseData) : responseData;

    const pagination = {
      current: nextPage,
      pageSize,
      total,
    };

    yield put(gridSuccessAction({ endpoint, datos: outputData, pagination }));
  } catch (error) {
    yield put(gridFailureAction({ endpoint }));
    yield put(toastDanger({ httpError: error }));
  }
}

function* authenticationRequest() {
  yield takeEvery('GRIDEABLE_REQUEST', gridRequest);
}

export default authenticationRequest;
